module.exports = __webpack_public_path__ + "assets/content-management.9a745fff.svg";